export const stopStream: (stream: MediaStream) => void = (stream) => {
  if (!stream) {
    return;
  }

  stream.getTracks().forEach((track) => {
    track.stop();
    stream.removeTrack(track);
  });

  // @ts-ignore
  if (stream.stop) {
    // @ts-ignore
    stream.stop();
  }

  return;
};
